import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { EventCalendar } from '../../../Assets/icons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import classes from './ShowDateRange.module.css';
import clsx from 'clsx';
const ShowDateRange = ({
  value = {
    startDate: new Date('2024-01-01'),
    endDate: new Date('2024-01-30'),
    key: 'selection'
  },
  setter = () => {}
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const formatDate = (date) => {
    return date
      .toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: '2-digit'
      })
      .replace(',', '');
  };

  // Handle click outside
  const handleClickOutside = (e) => {
    if (!e.target.closest('.calendar-wrapper')) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={classes.container}>
      <div className={classes.wrapper} onClick={() => setIsOpen(!isOpen)}>
        <p className={classes.dateRange}>
          {formatDate(value[0].startDate)} - {formatDate(value[0].endDate)}
        </p>
        <EventCalendar />
      </div>

      {isOpen && (
        <div className={clsx('absolute z-50 mt-2 calendar-wrapper', classes.calendarWrapper)}>
          <DateRangePicker
            onChange={(item) => setter([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={value}
            months={2} // Show 2 months
            direction="horizontal"
            maxDate={new Date()} // Optional: prevent past date selection
            rangeColors={['var(--primary-color)']} // Customize the selection color
            showMonthAndYearPickers={true} // Allow month/year navigation
            showDateDisplay={false} // Hide the date display at the top
          />
        </div>
      )}
    </div>
  );
};

export default ShowDateRange;
